export default __webpack_public_path__ + "static/media/B01.521c848e.png";